import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-wheel-fitment-display',
  templateUrl: './wheel-fitment-display.component.html',
  styleUrls: ['./wheel-fitment-display.component.scss']
})
export class WheelFitmentDisplayComponent implements OnInit {
  @Input() checkfitment: boolean = false;
  @Input() vehicle: string = '';
  @Input() isSearchBySize: boolean = false;
  @Output() onCheckFitment = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Handles fitment check event from search form
   */
  handleFitmentCheck(fitmentData: any): void {
    this.onCheckFitment.emit(fitmentData);
  }

  /**
   * Determines if fitment search form should be shown
   */
  shouldShowFitmentForm(): boolean {
    return !this.checkfitment && !this.isSearchBySize;
  }
  /**
   * Determines if fitment success message should be shown
   */
  shouldShowFitmentSuccess(): boolean {
    return !!this.checkfitment && !this.isSearchBySize && !!this.vehicle;
  }

  /**
   * Determines if fitment failure message should be shown
   */
  shouldShowFitmentFailure(): boolean {
    return this.checkfitment === false && !this.isSearchBySize;
  }

  /**
   * Gets the vehicle display text
   */
  getVehicleText(): string {
    return this.vehicle || 'your vehicle';
  }
}
